import Vue from 'vue'
import { JwtCookie } from '../services/jwtCookie.service.js'

const instance = new Vue({
  data () {
    return {
      isAuthenticated: false,
      token: '',
      error: null,
      listeners: [],
      step: ''
    }
  },
  methods: {
    registerListener (listener) {
      this.listeners.push(listener)
    },
    getToken () {
      return `Bearer ${this.token}`
    },
    logIn (loginInfo) {
      this.token = loginInfo.data.token
      this.step = loginInfo.data.step
      this.isAuthenticated = true

      JwtCookie.setJwtCookie('fooshijwt', this.token, 7)
      JwtCookie.setJwtCookie('fooshistep', this.step, 7)
    },
    logout () {
      this.token = ''
      this.isAuthenticated = false
      this.step = ''
      JwtCookie.setJwtCookie('fooshijwt', this.token, 7)
      JwtCookie.setJwtCookie('fooshistep', this.step, 7)
    }
  },
  async created () {
    var jwt = JwtCookie.getJwtCookie('fooshijwt')

    if (!jwt) {
      this.logout()
    } else {
      this.token = jwt
      this.isAuthenticated = true
      this.step = JwtCookie.getJwtCookie('fooshistep')
    }
  }
})

const Auth = {
  getInstance: () => instance
}

export default Auth



// WEBPACK FOOTER //
// ./src/auth/auth.js